import isNonGermanLocale from'./isNonGermanLocale';/**
 * The options a query needs to be read in another language - spread into `useQuery`.
 *
 * - `X-Mobility-Locale` tells the server which locale to resolve translated fields in.
 * - The fetch policy keeps the locales apart in Apollo's cache:
 *   - non-German (e.g. 'en'): no-cache - translations must not pollute the German cache
 *   - German ('de'): network-only - forces a fresh fetch so Apollo emits a new observable
 *     result; cache-first silently returns the stale pre-switch result and never re-renders
 *
 * Without a locale (the default view) nothing is overridden and `defaultFetchPolicy` applies -
 * left out, that is Apollo's own default (cache-first).
 */const localeQueryOptions=(locale,defaultFetchPolicy)=>{if(!locale)return{fetchPolicy:defaultFetchPolicy};return{fetchPolicy:isNonGermanLocale(locale)?'no-cache':'network-only',context:{headers:{'X-Mobility-Locale':locale}}};};export default localeQueryOptions;